export default {
  INVOICESLISTS(state) {
    return state.invoicesLists;
  },
  RECEPTIONSLISTS(state) {
    return state.receptionsLists;
  },
}